import { DocumentThumbnail } from './DocumentThumbnail';
import { Button } from './ui/button';

interface DocumentCardProps {
  document: {
    id: string;
    fileName: string;
    fileType: string;
    fileSize: number;
    description?: string;
    createdAt: string;
    uploader?: {
      firstName: string;
      lastName: string;
    };
  };
  getDownloadUrl: (variables: { variables: { id: string } }) => Promise<any>;
  onPreview: () => void;
  onDownload: () => void;
  showUploader?: boolean;
}

export function DocumentCard({
  document,
  getDownloadUrl,
  onPreview,
  onDownload,
  showUploader = true,
}: DocumentCardProps) {
  const formatDateTime = (dateString: string) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  };

  const formatFileSize = (bytes: number) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
  };

  return (
    <div className="flex items-center gap-4 p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors group">
      {/* Thumbnail */}
      <DocumentThumbnail
        document={document}
        getDownloadUrl={getDownloadUrl}
        size={56}
        onClick={onPreview}
      />
      
      {/* Info */}
      <div className="flex-1 min-w-0">
        <button
          onClick={onPreview}
          className="text-sm font-semibold text-gray-900 hover:text-aalaw-red transition-colors text-left truncate block w-full"
          title={`Preview ${document.fileName}`}
        >
          {document.fileName}
        </button>
        {document.description && (
          <p className="text-xs text-gray-600 mt-1 truncate">{document.description}</p>
        )}
        <p className="text-xs text-gray-500 mt-1">
          {formatFileSize(document.fileSize)} • {formatDateTime(document.createdAt)}
          {showUploader && document.uploader && ` • ${document.uploader.firstName} ${document.uploader.lastName}`}
        </p>
      </div>
      
      {/* Actions */}
      <div className="flex items-center gap-2">
        <Button 
          variant="ghost" 
          size="sm"
          onClick={onPreview}
          className="opacity-0 group-hover:opacity-100 transition-opacity"
          title="Preview"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
        </Button>
        <Button 
          variant="outline" 
          size="sm"
          onClick={onDownload}
        >
          Download
        </Button>
      </div>
    </div>
  );
}
